import { initialState } from '.';

export function resetStore(store) {
  store.set(initialState());
}
